export const style = {
  author: {
    fontSize: `11px`,
    color: `#333`,
    textTransform: `uppercase`
  },
  more: {
    textDecoration: `none`,
    fontSize: `13px`,
    color: `#A94545`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/News/partials/SingleArticle/style/info.js